import { cva } from 'class-variance-authority';

import { cn } from '@heidi/utils';

import { focusRing } from '../styles/focus-ring';

// Disabled-state trigger overrides:
// - [&_svg]:text-text-disabled — pin accessory icons + chevron to disabled tint.
// - [&_button_svg]:text-current — exempt button-internal icons.
// - [&>svg]:opacity-100 — restore chevron to full opacity (its hardcoded opacity-50 is
//   unreadable once tinted disabled).
export const selectTriggerVariants = cva(
  cn(
    'flex w-full items-center justify-between gap-x-2 border border-border bg-surface transition-all duration-300 disabled:cursor-not-allowed disabled:bg-surface-disabled disabled:text-text-disabled data-[state=open]:border-border-strong data-[placeholder]:text-text-secondary disabled:data-[placeholder]:text-text-disabled [&>span]:block [&>span]:min-w-0 [&>span]:flex-1 [&>span]:truncate [&>span]:text-start disabled:[&>svg]:opacity-100 disabled:[&_button_svg]:text-current disabled:[&_svg]:text-text-disabled',
    focusRing
  ),
  {
    variants: {
      density: {
        comfortable: 'h-10 rounded-lg px-3 py-2 text-sm',
        compact: 'h-7 gap-x-1 rounded-md px-2.5 text-xs font-medium',
      },
    },
    defaultVariants: {
      density: 'comfortable',
    },
  }
);

export const selectScrollButtonClasses = cn(
  'flex cursor-default items-center justify-center py-1'
);

export const selectContentVariants = cva(
  'relative z-50 max-h-96 min-w-32 overflow-hidden rounded-lg border-0 bg-surface-elevated text-text-primary shadow-popover ring-1 ring-surface-elevated-border data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
  {
    variants: {
      density: {
        comfortable: '',
        compact: '',
      },
    },
    defaultVariants: {
      density: 'comfortable',
    },
  }
);

export const selectContentPopperVariants = cva(
  'max-h-[var(--radix-select-content-available-height)] origin-[var(--radix-select-content-transform-origin)] data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1'
);

export const selectContentViewportClasses = 'p-1';

export const selectContentViewportPopperClasses =
  'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]';

export const selectLabelVariants = cva('pe-2 font-normal text-text-secondary', {
  variants: {
    density: {
      comfortable: 'py-1 ps-2 text-xs',
      compact: 'py-1 ps-2 text-xs',
    },
  },
  defaultVariants: {
    density: 'comfortable',
  },
});

export const selectItemVariants = cva(
  'relative flex w-full cursor-default select-none items-center gap-2 rounded-md outline-none hover:bg-surface-hover hover:text-text-primary focus:bg-surface-hover focus:text-text-primary active:bg-surface-pressed data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
  {
    variants: {
      density: {
        comfortable: 'py-2 text-sm',
        compact: 'py-1 text-xs font-medium',
      },
    },
    defaultVariants: {
      density: 'comfortable',
    },
  }
);

export const selectSeparatorClasses = cn('-mx-1 my-1 h-px bg-background-secondary');
